import React from "react";
import PropTypes from "prop-types";
import { Card, Typography } from "antd";
import moment from "moment";
const { Paragraph } = Typography;
import { PermissionContextManager } from "hocs";
import { UI_PERMISSIONS } from "constants";

class CreditAppraisalDateOfIncorporation extends React.Component {
    onChange = value => {
        this.value = moment(value).format("YYYY-MM-DD");
        if (this.value === this.props.dateOfIncorporation) {
            return;
        }
        this.props.update(this.value);
    };
    render() {
        if (!this.value) {
            this.value = this.props.dateOfIncorporation;
        }
        return (
            <Card className={"small-card-title"} title={"Date of Incorporation"}>
                <Paragraph
                    editable={((!this.props.isRiskApprover
                        && this.props.isUserAllowedToEdit)
                        || this.props.DATE_OF_INCORPORATION_EDIT) && !this.props.recreditViewOnlyPermission ? {
                            onChange: this.onChange
                        } : false}
                    className={"d-flex justify-content-space-between"}
                    level={4}
                >
                    {this.value ? moment(this.value).format("DD MMM YYYY") : "--"}
                </Paragraph>
            </Card>
        );
    }
}

CreditAppraisalDateOfIncorporation.propTypes = {
    dateOfIncorporation: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string
    ]),
    update: PropTypes.func,
    isRiskApprover: PropTypes.bool,
    DATE_OF_INCORPORATION_EDIT: PropTypes.bool,
    isUserAllowedToEdit: PropTypes.bool,
    recreditViewOnlyPermission: PropTypes.bool,
};

export default PermissionContextManager({
    propsPermissions: {
        DATE_OF_INCORPORATION_EDIT: UI_PERMISSIONS.DATE_OF_INCORPORATION_EDIT
    }
})(CreditAppraisalDateOfIncorporation);
